import React, { useEffect, useRef, useState } from "react";
import { mergeStyles, SearchBox } from "@fluentui/react";
import { SEARCH_DEBOUNCE_MS } from "./customizationSearch";

const searchBar = mergeStyles(
    {
        flex: '0 0 auto',
        padding: 'var(--druid-space-16) var(--druid-space-24) var(--druid-space-12) 0',
        '.ms-SearchBox': {
            maxWidth: 480,
            borderRadius: 4,
            border: '1px solid var(--druid-color-border)',
        },
        '.ms-SearchBox:hover': {
            borderColor: 'var(--druid-color-success-primary)',
        },
        '.ms-SearchBox.is-active::after': {
            border: '2px solid var(--druid-color-success-primary)',
            borderRadius: 4,
        },
    }
);

interface Props {
    value: string;
    placeholder: string;
    onChange: (query: string) => void;
}

export const CustomizationSearchBox = (props: Props) => {
    const { value, placeholder, onChange } = props;
    const [text, setText] = useState(value);
    const timer = useRef<number>();

    useEffect(() => {
        window.clearTimeout(timer.current);
        setText(value);
    }, [value]);

    useEffect(() => () => window.clearTimeout(timer.current), []);

    const onTextChange = (_event?: React.ChangeEvent<HTMLInputElement>, newValue: string = '') => {
        setText(newValue);
        window.clearTimeout(timer.current);
        if (newValue.trim()) {
            timer.current = window.setTimeout(() => onChange(newValue), SEARCH_DEBOUNCE_MS);
        } else {
            onChange('');
        }
    };

    return (
        <div className={searchBar}>
            <SearchBox
                value={text}
                placeholder={placeholder}
                ariaLabel={placeholder}
                onChange={onTextChange}
            />
        </div>
    );
};

export default CustomizationSearchBox;
